module.exports = __webpack_public_path__ + "img/largada-esportiva-horizontal-negative.dd073795.svg";